import {Record} from 'immutable';
import {ReviewId} from 'records/ReviewId';

export default class CoachingReviewAnswer extends Record({
  score: undefined,
  comment: undefined,
  reviewQuestionId: undefined,
  reviewId: undefined,
}) {
  readonly score?: number;
  readonly comment?: number;
  readonly reviewQuestionId: number;
  readonly reviewId: ReviewId;
}
